import { render, staticRenderFns } from "./manage-product-likeables-modal.vue?vue&type=template&id=d6e3faf0&scoped=true&"
import script from "./manage-product-likeables-modal.vue?vue&type=script&lang=js&"
export * from "./manage-product-likeables-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6e3faf0",
  null
  
)

export default component.exports